<template>
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5.51795V10.7587C0 12.2678 1.22339 13.4912 2.73256 13.4912H15.2674C16.7766 13.4912 18 12.2678 18 10.7587V5.51795C18 5.25551 17.7872 5.04272 17.5248 5.04272H0.475227C0.212783 5.04272 0 5.25551 0 5.51795ZM5.05591 8.84455H3.78863C3.32933 8.84455 2.95698 8.47221 2.95698 8.0129C2.95698 7.55359 3.32933 7.18125 3.78863 7.18125H5.05591C5.51521 7.18125 5.88755 7.55359 5.88755 8.0129C5.88755 8.47221 5.51521 8.84455 5.05591 8.84455Z" fill="currentColor" />
    <path d="M18 2.90416V2.73256C18 1.22339 16.7766 0 15.2674 0H2.73256C1.22339 0 0 1.22339 0 2.73256V2.90416C0 3.1666 0.212783 3.37938 0.475227 3.37938H17.5248C17.7872 3.37938 18 3.1666 18 2.90416Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Card',
};
</script>
